module.exports = __webpack_public_path__ + "fonts/626b87f1/aboutme-glyphs.ttf";